export default __webpack_public_path__ + "static/news17-c9026e9eb5881ae7d979574da340a5ed.png";